import { Component, OnInit, OnDestroy, Output, EventEmitter, Inject } from '@angular/core';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subject, Subscription } from 'rxjs';
import { ImageCroppedEvent } from 'ngx-image-cropper';
import { Store, select } from '@ngrx/store';
import { AppState } from '../../store/model';

@Component({
    selector: 'app-modal-crop',
    templateUrl: './modal-crop.component.html',
    styleUrls: ['./user-crop-image.component.scss'],
    standalone: false
})
export class ModalCropComponent implements OnInit, OnDestroy {
    imageEvent: any;
    imageCroppedEvent: ImageCroppedEvent;
    croppedImage: string | null = null;
    isProcessing = false;
    loadFailed = false;

    readonly cropperConfig = {
        maintainAspectRatio: true,
        aspectRatio: 1,
        resizeToWidth: 300,
        resizeToHeight: 300,
        cropperMinWidth: 100,
        cropperMinHeight: 100,
        onlyScaleDown: true,
        alignImage: 'center',
        roundCropper: true
    };

    constructor(
        public dialogRef: MatDialogRef<ModalCropComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { event: any }
    ) {}

    ngOnInit() {
        this.imageEvent = this.data.event;
    }

    ngOnDestroy() {
        this.imageEvent = null;
        this.imageCroppedEvent = null;
        this.croppedImage = null;
    }

    onImage() {
        if (this.croppedImage) {
            this.isProcessing = true;

            // Corrigido: Removida a conversão para File que causava erro
            this.dialogRef.close({
                base64: this.croppedImage,
                width: this.cropperConfig.resizeToWidth,
                height: this.cropperConfig.resizeToHeight
            });
        }
    }

    onClose() {
        this.dialogRef.close(null);
    }

    imageCropped(event: ImageCroppedEvent) {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        const size = Math.min(event.width, event.height);

        canvas.width = size;
        canvas.height = size;

        const img = new Image();
        img.src = event.base64 || event.objectUrl;
        img.onload = () => {
            ctx.beginPath();
            ctx.arc(size / 2, size / 2, size / 2, 0, Math.PI * 2);
            ctx.closePath();
            ctx.clip();

            ctx.drawImage(img,
                (size - event.width) / 2,
                (size - event.height) / 2,
                event.width,
                event.height
            );

            this.croppedImage = canvas.toDataURL('image/png');
        };
    }

    imageLoaded() {
        this.loadFailed = false;
    }

    loadImageFailed() {
        this.loadFailed = true;
    }
}

@Component({
    selector: 'app-user-crop-image',
    templateUrl: './user-crop-image.component.html',
    styleUrls: ['./user-crop-image.component.scss'],
    standalone: false
})
export class UserCropImageComponent implements OnInit, OnDestroy {
    readonly modal_open$ = this.store.pipe(select((state: AppState) => state.Users.modal_crop_image));
    readonly cropEvent$ = this.store.pipe(select((state: AppState) => state.Users.crop_event));

    currentDialog: MatDialogRef<any, any> = null;
    destroy = new Subject<void>();
    subDialog: Subscription;
    subModal: Subscription;
    subCropEvent: Subscription;

    @Output() imageEmitter: EventEmitter<{
        base64: string;
        width: number;
        height: number;
    }> = new EventEmitter();

    constructor(
        public dialog: MatDialog,
        private readonly store: Store<AppState>
    ) {}

    ngOnInit() {
        this.subModal = this.modal_open$.subscribe(modal => {
            if (modal) {
                this.subCropEvent = this.cropEvent$.subscribe(cropEvent => {
                    if (cropEvent) {
                        this.openCropperDialog(cropEvent);
                    }
                });
            } else {
                this.closeCurrentDialog();
            }
        });
    }

    private openCropperDialog(cropEvent: any) {
        this.currentDialog = this.dialog.open(ModalCropComponent, {
            width: '500px',
            height: '580px',
            maxWidth: '95vw',
            maxHeight: '95vh',
            panelClass: 'custom-crop-dialog',
            disableClose: true,
            data: { event: cropEvent }
        });

        this.subDialog = this.currentDialog.afterClosed().subscribe(result => {
            if (result) {
                this.imageEmitter.emit(result);
            }
        });
    }

    private closeCurrentDialog() {
        this.currentDialog?.close();
        this.subCropEvent?.unsubscribe();
        this.subDialog?.unsubscribe();
    }

    ngOnDestroy() {
        this.destroy.next();
        this.destroy.complete();
        this.closeCurrentDialog();
        this.subModal?.unsubscribe();
    }
}
